module.exports = __webpack_public_path__ + "static/media/four.06770b28.svg";